import { createContext } from 'react';
import noop from 'lodash/noop';

const RecentSearchesContext = createContext(noop);

export default RecentSearchesContext;
